module.exports = __webpack_public_path__ + "img/banner1.89767d49.jpg";